import {useEffect} from "react";
import {Button, Nav} from "react-bootstrap";
import {Link} from "react-router-dom";

export default function NoAccess() {
  useEffect(() => {
    document.title = "QLI Artifacts | Access Denied"
  }, []);
  
  return (
    <div className="no-access">
      <span>You have no access to this page. Please contact your administrator if you think this is a mistake.</span>
      <Button variant="outline-danger">
        <Nav.Link as={Link} to="/">Home</Nav.Link>
      </Button>
    </div>
  )
};
